(function(){
function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
document.addEventListener('change',function(e){if(e.target.matches('[data-autosubmit]'))e.target.form.submit()});
document.addEventListener('click',function(e){qa('details.locale[open]').forEach(function(d){if(!d.contains(e.target))d.removeAttribute('open')})});
document.addEventListener('click',function(e){var b=e.target.closest('[data-qty-step]');if(!b)return;var w=b.closest('.qty'),i=w.querySelector('input');var v=Math.max(+i.min||0,(parseInt(i.value,10)||0)+(+b.dataset.qtyStep));i.value=v;if(i.form&&i.form.hasAttribute('data-cart-form'))i.form.submit()});

function gallery(){var g=document.querySelector('[data-gallery]');if(!g)return;var main=g.querySelector('.product__main img');if(!main)return;
qa('.thumb',g).forEach(function(t){t.addEventListener('click',function(){qa('.thumb',g).forEach(function(x){x.classList.remove('is-on')});t.classList.add('is-on');main.removeAttribute('srcset');main.src=t.dataset.src})})}

function variants(){var pf=document.querySelector('[data-product-form]');if(!pf)return;var js=document.querySelector('[data-product-json]');if(!js)return;
var list=JSON.parse(js.textContent),idIn=pf.querySelector('[data-variant-id]'),btn=pf.querySelector('[data-add]'),price=document.querySelector('[data-price]'),msg=document.querySelector('[data-variant-msg]'),cur=pf.dataset.currency;
function fmt(c){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cur}).format(c/100)}catch(err){return (c/100).toFixed(2)}}
pf.addEventListener('change',function(e){if(!e.target.matches('[data-opt]'))return;var sel=[];qa('[data-opt]:checked',pf).forEach(function(r){sel[+r.dataset.opt]=r.value});
var lab=pf.querySelector('[data-opt-label="'+e.target.dataset.opt+'"]');if(lab)lab.textContent=e.target.value;
var v=list.find(function(x){return x.options.every(function(o,i){return o===sel[i]})});
if(!v){btn.disabled=true;btn.textContent=btn.dataset.unavailable;return}
idIn.value=v.id;if(price)price.textContent=fmt(v.price);btn.disabled=!v.available;btn.textContent=v.available?btn.dataset.addLabel:btn.dataset.soldout;
if(msg){msg.hidden=v.available;msg.textContent=msg.dataset.tpl.replace('%s',sel.join(' / '))}
var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString())})}

function video(){var vb=document.querySelector('[data-video]');if(!vb)return;
var host=vb.querySelector('.video__host'),fac=vb.querySelector('.video__facade'),sh=vb.querySelector('[data-video-shuffle]'),title=vb.querySelector('[data-video-title]'),lab=vb.querySelector('[data-video-label]'),link=vb.querySelector('[data-video-link]');
var latest=vb.dataset.id,cur=latest,player=null,ids=null,onCued=null,shLabel=sh?sh.innerHTML:'';
function loadYT(){if(window.YT&&window.YT.Player)return Promise.resolve();return window.__omaYT||(window.__omaYT=new Promise(function(r){var prev=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){if(prev)prev();r()};var s=document.createElement('script');s.src='https://www.youtube.com/iframe_api';document.head.appendChild(s)}))}
function busy(b){if(!sh)return;sh.disabled=b;sh.innerHTML=b?sh.dataset.busy:shLabel}
function ensure(){return loadYT().then(function(){return new Promise(function(res){if(player)return res(player);var el=document.createElement('div');host.appendChild(el);
player=new YT.Player(el,{width:'100%',height:'100%',videoId:cur,playerVars:{rel:0,playsinline:1,origin:location.origin},events:{onReady:function(){res(player)},
onStateChange:function(e){if(e.data===5&&onCued){var f=onCued;onCued=null;f()}if(e.data===1){var d=e.target.getVideoData();if(d&&d.video_id){cur=d.video_id;if(d.title)title.textContent=d.title;lab.textContent=cur===latest?lab.dataset.latest:lab.dataset.other;link.href='https://www.youtube.com/watch?v='+cur}busy(false)}},
onError:function(){busy(false)}}})})})}
function pick(p){var l=(ids||[]).filter(function(i){return i!==cur});if(!l.length){busy(false);return}cur=l[Math.floor(Math.random()*l.length)];p.loadVideoById(cur)}
fac.addEventListener('click',function(){fac.hidden=true;ensure().then(function(p){p.playVideo()})});
if(sh)sh.addEventListener('click',function(){busy(true);fac.hidden=true;ensure().then(function(p){if(ids)return pick(p);onCued=function(){ids=p.getPlaylist()||[];pick(p)};p.cuePlaylist({listType:'playlist',list:vb.dataset.playlist});setTimeout(function(){if(onCued){onCued=null;busy(false)}},6000)})})}

function bandsintown(){var bit=document.querySelector('[data-bit]');if(!bit)return;var list=bit.querySelector('[data-bit-list]'),d=bit.dataset,artist=d.artist||'OMA';
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function empty(){list.innerHTML=bit.querySelector('[data-bit-empty]').innerHTML}
if(!d.appId){empty();return}
fetch('https://rest.bandsintown.com/artists/'+encodeURIComponent(artist)+'/events?app_id='+encodeURIComponent(d.appId)+'&date=upcoming').then(function(r){if(!r.ok)throw r.status;return r.json()}).then(function(evs){
if(!Array.isArray(evs)||!evs.length)return empty();var loc=document.documentElement.lang||'en';
list.innerHTML=evs.map(function(e){var of=e.offers||[];var o=of.filter(function(x){return x.type==='Tickets'})[0]||of[0];var out=o&&o.status&&o.status.toLowerCase()==='sold out';var v=e.venue||{};
var g=(e.lineup||[]).filter(function(n){return n.toLowerCase()!==artist.toLowerCase()});
var date=new Date(e.datetime).toLocaleDateString(loc,{weekday:'short',day:'2-digit',month:'short'}).replace(',','').toUpperCase();
var meta=esc(v.name)+(v.country&&v.country!=='United Kingdom'?' · '+esc(v.country):'')+(g.length?' · '+esc(d.lWith.replace('%s',g.join(', '))):'');
return '<div class="event"><div class="event__date">'+esc(date)+'</div><div class="event__main"><div class="event__city">'+esc(v.city)+'</div><div class="mono muted">'+meta+'</div></div><div class="event__act">'+(out?'<span class="badge badge--live">'+esc(d.lSoldout)+'</span>':'')+'<a class="btn btn--ghost" href="'+esc(e.url)+'" target="_blank" rel="noopener">'+esc(d.lRsvp)+'</a>'+(o&&!out?'<a class="btn btn--primary" href="'+esc(o.url)+'" target="_blank" rel="noopener">'+esc(d.lTickets)+'</a>':'')+'</div></div>'}).join('')}).catch(empty)}

gallery();variants();video();bandsintown();
})();
/* OMA – "New release" hero always shows the latest long-form YouTube video */
(function () {
  var hero = document.querySelector('[data-latest-video]') || document.querySelector('[id$="__release"] .hero');
  if (!hero) return;

  var vb = document.querySelector('[data-video][data-playlist]');
  var LIST = (vb && vb.dataset.playlist) || 'UULFgtSzqR7D0-BgEFcfhrmWVA'; // OMA long-form uploads, newest first
  var KEY = 'oma-latest-video';
  var TTL = 3 * 60 * 60 * 1000; // re-check YouTube at most every 3 hours per visitor

  function apply(v) {
    var url = 'https://www.youtube.com/watch?v=' + v.id;
    var cover = hero.querySelector('.hero__cover');
    var img = cover && cover.querySelector('img');
    if (cover) {
      cover.href = url;
      cover.classList.add('hero__cover--video');
    }
    if (img) {
      img.removeAttribute('srcset');
      img.onerror = function () {
        img.onerror = null;
        img.src = 'https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg';
      };
      img.src = 'https://i.ytimg.com/vi/' + v.id + '/maxresdefault.jpg';
      img.alt = v.title;
      img.width = 1280;
      img.height = 720;
    }
    var kicker = hero.querySelector('.kicker');
    if (kicker) kicker.textContent = 'New video';
      var h1 = hero.querySelector('h1');
    if (h1) {
      h1.textContent = v.title;
      var n = v.title.length;
      var scale = n <= 28 ? 1 : n <= 45 ? 0.8 : n <= 70 ? 0.62 : 0.55;
      h1.style.fontSize = 'calc(var(--fs-display-2) * ' + scale + ')';
    }
    var btn = hero.querySelector('.btn--primary');
    if (btn) {
      btn.href = url;
      btn.textContent = 'Watch on YouTube \u2197\uFE0E';
    }
  }

  var cached = null;
  try { cached = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
  if (cached && cached.id) {
    apply(cached);
    if (Date.now() - cached.t < TTL) return;
  }

  function loadYT() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    return window.__omaYT || (window.__omaYT = new Promise(function (r) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { prev && prev(); r(); };
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    }));
  }

  function fetchLatest() {
    loadYT().then(function () {
      var box = document.createElement('div');
      box.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;overflow:hidden';
      box.setAttribute('aria-hidden', 'true');
      var el = document.createElement('div');
      box.appendChild(el);
      document.body.appendChild(box);
      var tries = 0;
      var player = new YT.Player(el, {
        width: 1, height: 1,
        playerVars: { listType: 'playlist', list: LIST, origin: location.origin },
        events: {
          onReady: function check() {
            var ids = player.getPlaylist && player.getPlaylist();
            if (!ids || !ids.length) {
              if (++tries < 30) return setTimeout(check, 200);
              return box.remove();
            }
            var d = player.getVideoData() || {};
            var v = { id: ids[0], title: d.video_id === ids[0] && d.title ? d.title : '', t: Date.now() };
            var done = function () {
              if (!v.title) { box.remove(); return; }
              try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
              if (!cached || cached.id !== v.id || cached.title !== v.title) apply(v);
              player.destroy();
              box.remove();
            };
            if (v.title) return done();
            fetch('https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent('https://www.youtube.com/watch?v=' + v.id))
              .then(function (r) { return r.json(); })
              .then(function (j) { v.title = j.title || ''; done(); })
              .catch(function () { box.remove(); });
          }
        }
      });
    });
  }

  if (document.readyState === 'complete') fetchLatest();
  else window.addEventListener('load', fetchLatest);
})();
/* Stop iPhones turning the ↗ link arrows into an emoji */
(function () {
  var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n;
  while ((n = w.nextNode())) {
    if (n.nodeValue.indexOf('\u2197') > -1) {
      n.nodeValue = n.nodeValue.replace(/\u2197(?!\uFE0E)/g, '\u2197\uFE0E');
    }
  }
})();
/* Vinyl: tab on the Shop page + send vinyl buyers to elasticStage */
(function () {
    var EXTERNAL = {
    'bread-n-butter-vinyl': 'https://elasticstage.com/omavinyl/releases/bread-n-butter-album',
    'bread-n-butter-cd': 'https://elasticstage.com/omavinyl/releases/bread-n-butter-album',
     'tribe-vinyl': 'https://elasticstage.com/omavinyl/releases/a-tribute-called-quest-album'
  };

     document.querySelectorAll('.pills a[href="/pages/music"]').forEach(function (music) {
    var row = music.parentElement;
    if (row.querySelector('a[href="/collections/vinyl"]')) return;
    var vinyl = document.createElement('a');
    vinyl.className = 'pill';
    vinyl.href = '/collections/vinyl';
    vinyl.textContent = 'Vinyl';
    music.after(vinyl);
    if (location.pathname.indexOf('/collections/vinyl') === 0) {
      row.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('is-on'); });
      vinyl.classList.add('is-on');
    }
  });

  document.querySelectorAll('a[href="/collections/prints"]').forEach(function (a) {
    a.href = '/pages/prints';
  });

  document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
    var handle = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
    if (EXTERNAL[handle]) { a.href = EXTERNAL[handle]; a.target = '_blank'; a.rel = 'noopener'; }
  });

  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (m && EXTERNAL[m[1]]) {
    var form = document.querySelector('.product__form');
    if (form) {
      var btn = document.createElement('a');
      btn.className = 'btn btn--primary btn--lg';
      btn.href = EXTERNAL[m[1]];
      btn.target = '_blank';
      btn.rel = 'noopener';
      btn.textContent = 'Buy on elasticStage \u2197\uFE0E';
      form.replaceWith(btn);
    }
    document.querySelectorAll('.accs .acc').forEach(function (acc) {
      var title = acc.querySelector('summary').textContent.trim().toLowerCase();
      var body = acc.querySelector('.acc__body');
      if (title === 'shipping') body.textContent = 'Pressed to order and shipped worldwide by elasticStage. Shipping cost and delivery time are shown at their checkout.';
      if (title === 'returns') body.textContent = 'Vinyl orders are handled by elasticStage, so returns and order questions go through them.';
    });
  }
})();
/* Prints page: add the shop tabs so people can get back to the shop */
(function () {
  if (location.pathname !== '/pages/prints') return;
  var head = document.querySelector('.page-head');
  if (!head || head.querySelector('.pills')) return;
  if (!head.querySelector('.kicker')) {
    var k = document.createElement('div');
    k.className = 'kicker';
    k.textContent = 'Shop';
    head.prepend(k);
  }
  var tabs = [
    ['All', '/collections/all'],
    ['Clothing', '/collections/clothing'],
    ['Music', '/pages/music'],
    ['Vinyl', '/collections/vinyl'],
    ['Prints', '/pages/prints']
  ];
  var row = document.createElement('div');
  row.className = 'pills';
  tabs.forEach(function (t) {
    var a = document.createElement('a');
    a.className = 'pill' + (t[1] === '/pages/prints' ? ' is-on' : '');
    a.href = t[1];
    a.textContent = t[0];
    row.appendChild(a);
  });
  head.appendChild(row);
})();